<template>
     <b-collapse id="collapse-filtro" v-model="showFilter" class="mt-2 mb-5">
        <p>Aplique un filtrado de los recursos</p>
        <b-row>
            <b-col>                
                <b-form-input placeholder="Ingrese palabra clave" v-model.trim="dataFilter.wordSearch" type="text" v-on:keyup=" ($event) => { $event.key == 'Enter' ? targetFilter(): false }" ></b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="mt-3 text-center">
                <b-button variant="primary" @click="targetFilter" >
                    <font-awesome-icon icon="filter" /> Filtrar
                </b-button>
                <b-button class="ml-2 btn-sec" variant="" @click="resetFilter" >
                    <font-awesome-icon icon="trash" /> Limpiar
                </b-button>
            </b-col>
        </b-row>
        <hr>
    </b-collapse>
</template>

<script>
    export default {
       name: 'filtro-directorios',
       props: {
           showFilter: {
               type:Boolean,
               default: false
           },
           disableType: {
               type:Boolean,
               default:false
           }
       },
       data() {
           return {
               dataFilter: {
                   wordSearch:''
               }
           }
       },
       methods:{
           targetFilter() {
               this.$emit('filter',this.dataFilter);
           },
           resetFilter() {
               this.dataFilter.wordSearch = '';
               this.$emit('reset');
           }
       }
    }
</script>

<style lang="scss" scoped>

</style>